/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { StageInstanceHistoryItem } from '../model';
// @ts-ignore
import { StageInstanceSummary } from '../model';
// @ts-ignore
import { StageInstanceVoteRequest } from '../model';
// @ts-ignore
import { StageTransitionRequest } from '../model';
/**
 * StagesApi - axios parameter creator
 * @export
 */
export const StagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Stage instance ribbon for an entity
         * @summary ribbon on details screen for stage instance
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageInstanceHistory: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getStageInstanceHistory', 'entityId', entityId)
            const localVarPath = `/stages/entities/{entityId}/history`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stage instance ribbon for an entity
         * @summary ribbon on details screen for stage instance
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageInstanceSummary: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getStageInstanceSummary', 'entityId', entityId)
            const localVarPath = `/stages/entities/{entityId}/summary`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transitions a stage
         * @summary transitions a stage
         * @param {StageTransitionRequest} stageTransitionRequest StageTransitionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitionStage: async (stageTransitionRequest: StageTransitionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stageTransitionRequest' is not null or undefined
            assertParamExists('transitionStage', 'stageTransitionRequest', stageTransitionRequest)
            const localVarPath = `/stages/stages/transition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stageTransitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * vote a stage
         * @summary vote for stage
         * @param {number} stageInstanceId StageInstance ID
         * @param {StageInstanceVoteRequest} stageInstanceVoteRequest StageInstanceVoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vote: async (stageInstanceId: number, stageInstanceVoteRequest: StageInstanceVoteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stageInstanceId' is not null or undefined
            assertParamExists('vote', 'stageInstanceId', stageInstanceId)
            // verify required parameter 'stageInstanceVoteRequest' is not null or undefined
            assertParamExists('vote', 'stageInstanceVoteRequest', stageInstanceVoteRequest)
            const localVarPath = `/stages/instances/{stageInstanceId}/vote`
                .replace(`{${"stageInstanceId"}}`, encodeURIComponent(String(stageInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stageInstanceVoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StagesApi - functional programming interface
 * @export
 */
export const StagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Stage instance ribbon for an entity
         * @summary ribbon on details screen for stage instance
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStageInstanceHistory(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StageInstanceHistoryItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStageInstanceHistory(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Stage instance ribbon for an entity
         * @summary ribbon on details screen for stage instance
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStageInstanceSummary(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageInstanceSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStageInstanceSummary(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Transitions a stage
         * @summary transitions a stage
         * @param {StageTransitionRequest} stageTransitionRequest StageTransitionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transitionStage(stageTransitionRequest: StageTransitionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transitionStage(stageTransitionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * vote a stage
         * @summary vote for stage
         * @param {number} stageInstanceId StageInstance ID
         * @param {StageInstanceVoteRequest} stageInstanceVoteRequest StageInstanceVoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vote(stageInstanceId: number, stageInstanceVoteRequest: StageInstanceVoteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vote(stageInstanceId, stageInstanceVoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StagesApi - factory interface
 * @export
 */
export const StagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StagesApiFp(configuration)
    return {
        /**
         * Stage instance ribbon for an entity
         * @summary ribbon on details screen for stage instance
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageInstanceHistory(entityId: number, options?: any): AxiosPromise<Array<StageInstanceHistoryItem>> {
            return localVarFp.getStageInstanceHistory(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Stage instance ribbon for an entity
         * @summary ribbon on details screen for stage instance
         * @param {number} entityId Entity ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageInstanceSummary(entityId: number, options?: any): AxiosPromise<StageInstanceSummary> {
            return localVarFp.getStageInstanceSummary(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Transitions a stage
         * @summary transitions a stage
         * @param {StageTransitionRequest} stageTransitionRequest StageTransitionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitionStage(stageTransitionRequest: StageTransitionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.transitionStage(stageTransitionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * vote a stage
         * @summary vote for stage
         * @param {number} stageInstanceId StageInstance ID
         * @param {StageInstanceVoteRequest} stageInstanceVoteRequest StageInstanceVoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vote(stageInstanceId: number, stageInstanceVoteRequest: StageInstanceVoteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.vote(stageInstanceId, stageInstanceVoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StagesApi - object-oriented interface
 * @export
 * @class StagesApi
 * @extends {BaseAPI}
 */
export class StagesApi extends BaseAPI {
    /**
     * Stage instance ribbon for an entity
     * @summary ribbon on details screen for stage instance
     * @param {number} entityId Entity ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesApi
     */
    public getStageInstanceHistory(entityId: number, options?: any) {
        return StagesApiFp(this.configuration).getStageInstanceHistory(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stage instance ribbon for an entity
     * @summary ribbon on details screen for stage instance
     * @param {number} entityId Entity ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesApi
     */
    public getStageInstanceSummary(entityId: number, options?: any) {
        return StagesApiFp(this.configuration).getStageInstanceSummary(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transitions a stage
     * @summary transitions a stage
     * @param {StageTransitionRequest} stageTransitionRequest StageTransitionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesApi
     */
    public transitionStage(stageTransitionRequest: StageTransitionRequest, options?: any) {
        return StagesApiFp(this.configuration).transitionStage(stageTransitionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * vote a stage
     * @summary vote for stage
     * @param {number} stageInstanceId StageInstance ID
     * @param {StageInstanceVoteRequest} stageInstanceVoteRequest StageInstanceVoteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesApi
     */
    public vote(stageInstanceId: number, stageInstanceVoteRequest: StageInstanceVoteRequest, options?: any) {
        return StagesApiFp(this.configuration).vote(stageInstanceId, stageInstanceVoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
